import React from "react";
import {Typography} from "@material-ui/core";

const Footer = () => {
    return (
        
<footer style={{backgroundColor:'#262526'}} class="bg-white dark:bg-gray-900">
    <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div class="md:flex md:justify-center">
          
          <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-white uppercase dark:text-white">Resources</h2>
                  <ul class="text-gray-500 dark:text-gray-400 font-medium">
                      <li class="mb-4">
                        <a href='https://www.khuranaandkhurana.com/about/knk-profile/'  style={{borderColor:'#404040'}}>About Us</a>
                      </li>
                      <li>
                          <a href='https://www.khuranaandkhurana.com/contact/' style={{borderColor:'#404040'}}>Contact Us</a>
                      </li>
                    <li>
                         
                      </li>
                  </ul>
              </div>
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-white uppercase dark:text-white">Join us</h2>
                  <ul class="text-gray-500 dark:text-gray-400 font-medium">
                      <li class="mb-2">
                          <a href='https://www.khuranaandkhurana.com/careers-internships/'  style={{borderColor:'#404040'}}>Careers & Internships</a>
                      </li>
                      <li class='mb-2'>
                          <a href='https://www.khuranaandkhurana.com/blog/' style={{borderColor:'#404040'}}>Blogs</a>

                      </li>
                    <li >
                          <a href='https://docs.google.com/forms/d/e/1FAIpQLSfUL7C2RSvnkXsyG6ObUdf31ttr_f2fBhQjKxkxkUGW6Ws86A/viewform' style={{borderColor:'#404040'}}>Feedback</a>

                      </li>
                  </ul>
              </div>
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-white uppercase dark:text-white">Legal</h2>
                  <ul class="text-gray-500 dark:text-gray-400 font-medium">
                      <li class="mb-2">
                          <a href='https://www.khuranaandkhurana.com/privacy-policy/' style={{borderColor:'#404040'}}>Privacy Policy</a>
                      </li>
                      <li class="mb-2">
                          <a href='https://www.khuranaandkhurana.com/terms-and-conditions/' style={{borderColor:'#404040'}}>Terms and Conditions</a>
                        
                      </li>
                    <li>
                          <a href='https://www.khuranaandkhurana.com/compliance-to-bar-council-rules/' style={{borderColor:'#404040'}}>Compliance To Bar Council Rules</a>
                        
                      </li>
                  </ul>
              </div>
          </div>
      </div>
      <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
      
      <div class="sm:flex sm:items-center sm:justify-between">
          <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">Copyright © 2007-2021 <a href="https://www.khuranaandkhurana.com/" class="hover:underline">Khurana And Khurana.</a>All rights reserved.
          </span>
         
      </div>
    </div>
</footer>

    )
}

export default Footer;